module.exports = __webpack_public_path__ + "img/Bathroom-cut.684adb8d.png";